import {Component, OnInit, ViewChild} from '@angular/core';
import {Helper} from '../../../../helpers/helper.service';
import {ActivatedRoute} from '@angular/router';
import {CollectionService} from '../../../Services/collection.service';
import {Collection} from '../../../Models/Collection';
import {Model} from '../../../Models/Model';
import {Observable} from 'rxjs';
import {ModelService} from '../../../Services/model.service';

@Component({
  selector: 'app-view-collection',
  templateUrl: './view-collection.component.html',
  styleUrls: ['./view-collection.component.scss']
})
export class ViewCollectionComponent implements OnInit {
  public collectionId: number;
  public modelId;
  public modelName;
  public collection: Collection = new Collection();
  public models: Observable<Model[]>;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;

  constructor(private route: ActivatedRoute, private collectionService: CollectionService, private modelService: ModelService) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.collectionId = params['id'];
        this.getCollectionItem();
      }
    });
  }


  showDeleteModal(id, name) {
    this.modelId = id;
    this.modelName = name;
    this.deleteModal.show();
  }

  softDelete() {
    this.modelService.softDeleteModel(this.modelId).subscribe((res) => {
      this.getCollectionItem(() => {
        this.deleteModal.hide();
      });
    });
  }

  getCollection() {
    return Collection;
  }

  getModel() {
    return Model;
  }

  getCollectionItem(callback = null) {
    this.collectionService.getCollectionItem(this.collectionId).subscribe((resp) => {
      this.collection = resp;
      if (typeof callback === 'function') {
        callback();
      }
    });
  }

  positionChange(modelId, positionNumber) {
    const position = {position: positionNumber};
    this.collectionService.setParentPosition(modelId, position).subscribe(
      (res) => {
        this.getCollectionItem();
      }
    );
  }
}
